import React from 'react';
import './container.scss';

const Container = ({ children, style }) => (
  <div className="container" style={style}>
    {children}
  </div>
);

export default Container;
